import React, {useEffect, useState} from 'react';

// Define the types for the props of SvgIcon component
interface SvgIconProps {
  src: string;
  ariaHidden?: boolean;
}

const SvgIcon: React.FC<SvgIconProps> = ({src, ariaHidden = true}) => {
  const [svgContent, setSvgContent] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await fetch(src);
        if (!response.ok) {
          throw new Error(`Failed to fetch SVG: ${response.statusText}`);
        }
        const svgText = await response.text();
        const updatedSvg = svgText.replace(
          '<svg',
          '<svg aria-hidden="true" focusable="false"'
        );
        setSvgContent(updatedSvg);
      } catch (err) {
        console.error(err);
        setError('Failed to load SVG');
      }
    };

    fetchSvg();
  }, [src]);

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div
      aria-hidden={ariaHidden}
      className="aur-svg-icon"
      dangerouslySetInnerHTML={{__html: svgContent}}
    />
  );
};

// No additional props needed for MyComponent

const AurSvgIcon = (props: SvgIconProps) => {
  const {src, ...rest} = props;
  return <SvgIcon src={`/assests/${process.env.PUBLIC_URL}${src}`} {...rest} />;
};

export default AurSvgIcon;
